import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@AutoUnsubscribe()
@Component({
  selector: 'add-network-component',
  templateUrl: './add-network.component.html',
  styleUrls: ['./add-network.component.scss'],
})
export class AddNetworkComponent {
  @Input() public data: any;
  public editMode: boolean;
  public networkId: number;
  public networkData: any;
  public sharedDomains: Array<any>;
  public exclusiveDomains: Array<any>;
  public isLoading: boolean;
  public subscriptions: Array<any>;
  public uploadFileSizeLimit = 5;
  public files: Array<any>;

  constructor(
    public sharedService: SharedService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService
  ) {
    this.editMode = false;
    this.data = {
      accountManagers: [],
      domains: {
        shared_domains: [],
        exclusive_domains: [],
      },
      networkData: {},
    };
    this.networkData = {
      active: true,
      qa_network: false,
      publisher_io: false,
      archived: false,
      networkType: 'regular',
      network_domains: {
        shared_domains: [],
        exclusive_domains: [],
      },
    };
    this.sharedDomains = [];
    this.exclusiveDomains = [];
    this.isLoading = false;
    this.subscriptions = [];
    this.files = [];
  }

  ngOnDestroy() {}

  ngOnChanges($event: any) {
    let networkData: any;
    let accountManager: any;
    let defaultDomains: Array<any>;
    this.editMode = this.data.networkData;

    this.sharedDomains = this.data.domains.shared_domains;
    this.exclusiveDomains = this.data.domains.exclusive_domains;

    if (this.data.networkData) {
      this.networkData.active_supplies_limit = this.data.networkData.active_supplies_limit;
      this.networkData.active_demands_limit = this.data.networkData.active_demands_limit;
      this.networkData.max_cpm_limit = this.data.networkData.max_cpm_limit;
    }

    if (this.editMode) {
      this.networkId = this.data.networkData.networkId;
      networkData = _.cloneDeep(this.data.networkData);
      accountManager = _.find(this.data.accountManagers, { userId: this.data.networkData.am_id });
      networkData.am_id = accountManager ? accountManager.userId : null;
      networkData.active = networkData.active === '1';
      networkData.qa_network = networkData.qa_network === '1';
      networkData.publisher_io = networkData.publisher_io === '1';
      networkData.archived = networkData.archived === '1';
      networkData.network_domains = {
        shared_domains: _.each(this.data.networkData.network_domains.shared_domains, function (o) {
          o.id = o.domainId;
          delete o.domainId;
          return o;
        }),
        exclusive_domains: _.each(this.data.networkData.network_domains.exclusive_domains, function (o) {
          o.id = o.domainId;
          delete o.domainId;
          return o;
        }),
      };
      this.networkData = networkData;
      for (let i = 0; i < this.data.networkData.network_domains.exclusive_domains.length; i++) {
        this.exclusiveDomains.push({
          active: this.data.networkData.network_domains.exclusive_domains[i].active,
          domain: this.data.networkData.network_domains.exclusive_domains[i].domain,
          domain_type: this.data.networkData.network_domains.exclusive_domains[i].domain_type,
          id: this.data.networkData.network_domains.exclusive_domains[i].domainId,
        });
      }
    } else {
      const networkType = this.networkData.networkType;

      defaultDomains = _.filter(this.sharedDomains, function (o) {
        return o.default_setting_type !== '0' && o.default_for_network_types.includes(networkType);
      });

      this.networkData.network_domains = {
        shared_domains: defaultDomains,
        exclusive_domains: [],
      };
      if (this.data.accountManagers.length > 0) {
        accountManager = _.find(this.data.accountManagers, { email: 'test@cedato.com' });
        this.networkData.am_id = accountManager.userId;
      }
    }
  }

  onNetworkTypeChange() {
    const networkType = this.networkData.networkType;
    const defaultDomains = _.filter(this.sharedDomains, function (o) {
      return o.default_setting_type !== '0' && o.default_for_network_types.includes(networkType);
    });

    this.networkData.network_domains.shared_domains = defaultDomains;
  }

  validateForm() {
    let valid = true;
    let errorMessage: string;

    if (this.sharedService.isEmpty(this.networkData.name)) {
      valid = false;
      errorMessage = this.dictionaryService.get('NETWORK_NAME_IS_REQUIRED');
    }

    if (this.files.length > 0) {
      if (this.files[0].size > this.uploadFileSizeLimit * 1024 * 1024) {
        valid = false;
        errorMessage = this.dictionaryService.get('FILE_SIZE_EXCEED_ERROR')(this.uploadFileSizeLimit);
      }
    }

    if (!valid) {
      this.sharedService.showFlashMessage(errorMessage, 'error');
    }
    return valid;
  }

  saveNetwork() {
    if (this.validateForm()) {
      const url: string = this.editMode ? 'networks_management/updateNetworkData' : 'networks_management/createNetwork';
      const params: any = {
        networkData: {
          name: this.networkData.name,
          networkType: this.networkData.networkType,
          active: this.networkData.active ? 1 : 0,
          qa_network: this.networkData.qa_network ? 1 : 0,
          publisher_io: this.networkData.publisher_io ? 1 : 0,
          archived: this.networkData.archived ? 1 : 0,
          network_domains: {
            shared_domains: _.map(this.networkData.network_domains.shared_domains, 'id'),
            exclusive_domains: _.map(this.networkData.network_domains.exclusive_domains, 'id'),
          },
          active_supplies_limit: this.networkData.active_supplies_limit,
          active_demands_limit: this.networkData.active_demands_limit,
          max_cpm_limit: this.networkData.max_cpm_limit,
        },
      };

      if (!this.sharedService.isEmpty(this.networkData.am_id)) {
        params.networkData.am_id = this.networkData.am_id;
      }

      if (this.editMode) {
        params.networkId = this.networkId;
      }

      this.isLoading = true;

      const subscription = this.uploadPricePointsFile(params, 'networks_management/uploadTamPricePoints');

      subscription.subscribe((saveResponse: any) => {
        this.subscriptions.push(
          this.httpService.post(url, params).subscribe(
            (response: any) => {
              const title: string = this.editMode ? 'NETWORK_UPDATED_SUCCESSFULLY' : 'NETWORK_CREATED_SUCCESSFULLY';
              if (response.errors === undefined) {
                this.sharedService.showFlashMessage(this.dictionaryService.get(title), 'success');
                this.modalsService.hideModal();
                this.sharedService.sendMessage('NETWORK_UPDATED');
                this.isLoading = false;
              } else {
                this.sharedService.showErrorFlashMessage(response.errors);
                this.isLoading = false;
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage();
              this.modalsService.hideModal();
              this.isLoading = false;
            }
          )
        );
      });
    }
  }

  private uploadPricePointsFile(params: any, url: string) {
    return Observable.create((observer: Observer<any>) => {
      if (this.files.length > 0) {
        this.subscriptions.push(
          this.httpService.upload(url, params, this.files[0]).subscribe(
            (response: any) => {
              if (response.status.toLowerCase() !== 'error') {
                observer.next(response);
                observer.complete();
              } else {
                this.sharedService.showFlashMessage(response.msg, 'error');

                observer.next(false);
                observer.complete();
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage(error);

              observer.next(false);
              observer.complete();
            }
          )
        );
      } else {
        observer.next(false);
        observer.complete();
      }
    });
  }

  fileChanged($event) {
    this.files = $event;
  }
}
